import { z } from 'zod';

export const trainingStatusFilterSchema = z.object({
  valid: z.boolean(),
  expiring: z.boolean(),
  expired: z.boolean(),
  missing: z.boolean(),
});
